/*
 * Copyright (c) 2023, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

import React from 'react'
import {Route, Switch, useRouteMatch} from 'react-router'
import OrderHistory from './order-history'
import OrderDetail from './order-details/'
import {OrderProvider} from './order-context'

const Orders = () => {
    const {path} = useRouteMatch()

    return (
        <Switch>
            <Route exact path={path}>
                <OrderHistory />
            </Route>
            <Route path={`${path}/:orderId/:orderNo/:originalOrderId`}>
                <OrderProvider>
                    <OrderDetail />
                </OrderProvider>
            </Route>
        </Switch>
    )
}

Orders.getTemplateName = () => 'account-orders'

export default Orders
